import React, { useEffect, useState, createContext, useContext } from 'react';
type Theme = 'dark';
interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  // Always dark mode
  const theme: Theme = 'dark';
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light');
    root.classList.add('dark');
  }, []);
  const toggleTheme = () => {
    // No-op for dark mode only
  };
  return <ThemeContext.Provider value={{
    theme,
    toggleTheme
  }} data-id="element-542">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}